import { createAsyncThunk } from '@reduxjs/toolkit';

import { Category } from 'entities/Category';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface CreateCategoryServiceParams {
    catalogId: string;
    glCode: string;
    color: string;
    title: string;
}

export const createCategoryService = createAsyncThunk<
    Category,
    CreateCategoryServiceParams,
    ThunkConfig<string>
>(
    'category/CreateCategoryService',
    async ({ catalogId, title, color, glCode }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.post<{ category: Category }>(
                `/v1/catalogs/${catalogId}/categories`,
                {
                    color,
                    glCode,
                    title,
                },
            );
            return response.data.category;
        } catch (e) {
            const errorData = e?.response?.data;

            if (errorData) {
                return rejectWithValue(errorData);
            }

            return rejectWithValue('error');
        }
    },
);
